module.exports = __webpack_public_path__ + "img/zone150200.b43f4ebe.png";